/**
 * Subskill definitions for 6th-grade math progress diagnostics.
 *
 * A subskill is a fine-grained competency that cuts across topics. Topics tag
 * the subskills they exercise, so mastery tracking can aggregate performance by
 * underlying skill rather than only by topic.
 */

export const SUBSKILLS = {
  integerArithmetic: "Integer arithmetic",
  fractionArithmetic: "Fraction arithmetic",
  decimalArithmetic: "Decimal arithmetic",
  placeValue: "Place value understanding",
  signRules: "Sign rules for operations",
  numberLine: "Number line interpretation",
  equivalentForms: "Fraction/decimal/percent conversion",
  orderOfOperations: "Order of operations (PEMDAS)",
  variableRecognition: "Identify variables, terms, coefficients",
  substitution: "Substitution and evaluation",
  inverseOperations: "Inverse operations for solving",
  inequalityReasoning: "Inequality direction and graphing",
  distributive: "Distributive property",
  propertiesOfOps: "Properties of operations",
  ratioReasoning: "Ratio and rate reasoning",
  areaFormulas: "Area computation",
  surfaceAreaNets: "Surface area via nets",
  volumeFormulas: "Volume computation",
  angleRelationships: "Angle measurement and relationships",
  coordinateGraphing: "Coordinate plane graphing",
  statisticalMeasures: "Statistical measures (center/spread)",
  probabilityBasics: "Probability fundamentals",
  dataInterpretation: "Data display interpretation",
  exponents: "Whole-number exponents",
  reciprocals: "Multiplicative inverse (reciprocal)",
} as const;

export type SubskillId = keyof typeof SUBSKILLS;

export function subskillLabel(id: SubskillId): string {
  return SUBSKILLS[id];
}

export function isSubskillId(x: string): x is SubskillId {
  return Object.prototype.hasOwnProperty.call(SUBSKILLS, x);
}
